//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-payable/dashboard';

export default {
    data: function data() {
        return {
            overdueData: [],
            monthlyData: [],
            unpaidChartData: {
                headers: ["Invoice #", "Vendor", { title: 'Due Date', filter: 'dateFull' }, { title: 'Amount', filter: 'toCurrency' }],
                fields: ["number", "vendor.name", "due_date", "amount"],
                items: []

            },
            vendorChartData: {
                headers: ["Vendor", "Invoice", { title: 'Invoice Date', filter: 'dateFull' }, { title: 'Amount', filter: 'toCurrency' }],
                fields: ["vendor.name", "number", "invoice_date", "amount"],
                items: []
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.load();

        Event.$on('refresh-accounting-ap-dashboard', function () {
            return _this.load();
        });

        Event.$on('view-vendor-from-ap', function (item) {
            Event.$emit('view-vendor', item.vendor);
        });

        Event.$on('view-invoice-from-ap', function (item) {
            Event.$emit('view-ap-invoice', invoice);
        });
    },


    methods: {
        load: function load() {
            var _this2 = this;

            // get Overdue Chart
            axios.post(BASE_URL + "/overdue").then(function (response) {
                return _this2.overdueData = response.data;
            });

            // get Monthly Chart
            axios.post(BASE_URL + "/monthly").then(function (response) {
                return _this2.monthlyData = response.data;
            });

            // get Vendor Chart
            axios.post(BASE_URL + "/vendors").then(function (response) {
                _this2.vendorChartData.items = response.data;
            });

            // get Outstandin Chart
            axios.post(BASE_URL + "/outstanding").then(function (response) {
                _this2.unpaidChartData.items = response.data;
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/AccountsPayableDashboard.vue
// module id = ZBAM
// module chunks = 0 1